import {
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  SET_LOADING,
  CLEAR_ERROR,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  DEV_USER_LOGIN_SUCCESS,
  DEV_USER_LOGIN_FAIL,
} from './types.js';

const initialState = {
  loading: false,
  error: null,
  user: null,
  userProfile: null,
  devUser: null, // this is for dev login only
};

const authReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    case USER_DETAILS_SUCCESS:
      return {
        ...state,
        userProfile: action.payload[0],
        loading: false,
        error: null,
      };

    // user login and registration success
    case USER_LOGIN_SUCCESS:
      localStorage.setItem('centralize-admin-token', action.payload.token);
      localStorage.setItem(
        'centralize-admin-data',
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        user: action.payload,
        loading: false,
        error: null,
      };

    case DEV_USER_LOGIN_SUCCESS:
      localStorage.setItem('centralize-dev-user-token', action.payload.token);

      return {
        ...state,
        devUser: action.payload,
        loading: false,
        error: null,
      };
    // user auth error and logout
    case USER_LOGIN_FAIL:
    case USER_DETAILS_FAIL:
    case DEV_USER_LOGIN_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;
